module.exports = __webpack_public_path__ + "static/media/smoothsole-4.29cb5568.jpg";